import React from 'react';
import Header from '../components/Header';
import LoginView from '../views/LoginView';
import Footer from '../components/Footer';
import PageLayout from '../components/Layout/PageLayout';
import { useRecoilValue } from 'recoil';
import {  themeNameState } from '../';

export default function Login() {
  const themeName = useRecoilValue(themeNameState);
    
  return (
    <PageLayout gomo-theme-background={themeName === 'GOMOSMB'}>
      <Header />
      <LoginView />
      <Footer />
    </PageLayout>
  );
}